export default [
    {
        path: '/test',
        name: 'test',
        component: () => import('@ts2/ts-translation'),
        meta: { authorize: [] },
    }
]
